exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2nh496_rS_tt8ag_NQBGth{font-size:12px;width:256px}html[dir] ._2nh496_rS_tt8ag_NQBGth{padding:8px}._1xERwGWV-iZN3oRoF_fS2J{z-index:20}html[dir=ltr] ._1xERwGWV-iZN3oRoF_fS2J{margin:3px 0 0 4px}html[dir=rtl] ._1xERwGWV-iZN3oRoF_fS2J{margin:3px 4px 0 0}", ""]);
// Exports
exports.locals = {
	"callout": "_2nh496_rS_tt8ag_NQBGth",
	"iconStyle": "_1xERwGWV-iZN3oRoF_fS2J"
};